





























































































































import {Component, Vue} from 'vue-property-decorator';
import UpcomingBirthdayList from '@/components/home/UpcomingBirthdayList.vue';
import NewJoineesList from '@/components/home/NewJoineesList.vue';
import UpcomingHoliday from '@/components/home/UpcomingHoliday.vue';
import AnnouncementMarquee from '@/components/home/AnnouncementMarquee.vue';
import DocumentTile from '@/components/documents/DocumentTile.vue';
import PayrollClosingDate from '@/components/home/PayrollClosingDate.vue';
import ShiftTiming from '@/components/home/ShiftTiming.vue';
import WelcomeBoard from '@/components/home/WelcomeBoard.vue';
import ImageGallery from '@/components/home/ImageGallery.vue';
import KeyHire from '@/components/home/KeyHire.vue';
import Survey from '@/components/home/Survey.vue';
import PersonalDetailsPopUp from '@/components/home/PersonalDetailPopUp.vue';
import ProbationPopUp from '@/components/home/ProbationPop.vue';
import Appreciation from '@/components/home/Appreciation.vue';
import InTime from '@/components/home/InTime.vue';

import { IDocumentTileModel } from '@/models/common';

@Component({
    components: {
        UpcomingBirthdayList,
        NewJoineesList,
        UpcomingHoliday,
        AnnouncementMarquee,
        DocumentTile,
        PayrollClosingDate,
        ShiftTiming,
        WelcomeBoard,
        ImageGallery,
        KeyHire,
        Survey,
        PersonalDetailsPopUp,
        ProbationPopUp,
        Appreciation,
        InTime
    },
})
export default class Home extends Vue {
    public showAllBtn: boolean = true;
    public show: boolean = false;
    public d = new Date();
    public dressCodePolicy: IDocumentTileModel = {
        title: 'Gallery',
        subTitle: 'media',
        link: 'Sulekha_Dress_Code.pdf',
        img: 'Sulekha_Dress_Code.jpg',
    };
    get scl() {
        return '/scl';
    }
    get year() {
        const d = new Date();
        return d.getFullYear();
    }
}
